import { mapState } from "vuex";

export const knowsColors = {
    computed: {
        ...mapState({
            colors: state => state.Ente.colors.sfondo
        })
    }
};
